import { BoxShadowLayout } from "layouts";
import { ProductCell, ProductColorLabel } from "modules/products";
import { useParams } from "react-router-dom";
import { HeaderStatistic, Loader, Pagination, SearchInput } from "ui";

import { useProductPriceInsight } from "../../apis";
import { PriceInsightOrdersTable } from "../../components";
import { usePriceInsightsOrdersList } from "../../hooks";

import styles from "./ProductPriceInsight.module.scss";

const ProductPriceInsight = () => {
  const { productId } = useParams();

  const { productPriceInsight, isLoading } = useProductPriceInsight(productId);

  const {
    priceInsightOrders,
    searchValue,
    page,
    setPage,
    totalItems,
    setSearchValue,
    setSorting,
    sorting,
    isLoading: isLoadingPriceInsightOrders
  } = usePriceInsightsOrdersList(productId);

  return (
    <BoxShadowLayout className={styles.productPriceInsight}>
      {isLoading && <Loader />}

      {productPriceInsight && (
        <div className={styles.productPriceInsight_headerInfo}>
          <ProductCell
            image={productPriceInsight.image}
            name={productPriceInsight.name}
            imageClassName={styles.productPriceInsight_headerInfo_image}
            nameClassName={styles.productPriceInsight_headerInfo_name}
            subtitleClassName={styles.productPriceInsight_headerInfo_subtitle}
            subtitle={
              <>
                <span>{productPriceInsight.sku}</span>
                <span>·</span>
                <ProductColorLabel
                  colorValue={productPriceInsight.colorAttributeValue.value}
                />
              </>
            }
          />
          <HeaderStatistic
            valueClassName={
              styles.productPriceInsight_headerInfo_statisticValue
            }
            labelClassName={
              styles.productPriceInsight_headerInfo_statisticLabel
            }
            statistic={[
              { label: "Buying Price", value: productPriceInsight.buyingPrice },
              {
                label: "Standard Price",
                value: productPriceInsight.standardPrice
              },
              {
                label: "Average Selling Price",
                value: productPriceInsight.averageSellingPrice
              },
              {
                label: "Sold Range",
                value: `${productPriceInsight.minSellingPrice.toLocaleString(
                  "en-US"
                )} - ${productPriceInsight.maxSellingPrice.toLocaleString(
                  "en-US"
                )}`
              }
            ]}
          />
        </div>
      )}

      <SearchInput
        value={searchValue}
        onChange={setSearchValue}
        placeholder="Search..."
      />

      <div className={styles.productPriceInsight_table}>
        <PriceInsightOrdersTable
          orders={priceInsightOrders}
          isLoading={isLoadingPriceInsightOrders}
          sorting={sorting}
          setSorting={setSorting}
        />
      </div>

      <Pagination
        currentPage={page}
        totalItems={totalItems}
        onChange={setPage}
      />
    </BoxShadowLayout>
  );
};

export default ProductPriceInsight;
